import { z } from 'zod';

export const ManageEmailAlertsModalSchema = z.object({
  beachWithExperienceAlertActive: z.boolean(),
  clientCreatedAccountAlertActive: z.boolean(),
  clientCreatedOppAlertActive: z.boolean(),
  clientReqInterviewAlertActive: z.boolean(),
  clientSearchedInAfcAlertActive: z.boolean(),
  clientSignedInAlertActive: z.boolean(),
  talentSelectedOnOppAlertActive: z.boolean(),
  waitlistWithExperienceAlertActive: z.boolean(),
  savedSearchAlerts: z
    .array(
      z.object({
        id: z.string().uuid(),
        name: z.string(),
        alertActive: z.boolean(),
      })
    )
    .nullish(),
});

export type ManageEmailAlertsModalType = z.infer<
  typeof ManageEmailAlertsModalSchema
>;

export type ManageEmailAlertsModalSavedSearchAlert = NonNullable<
  ManageEmailAlertsModalType['savedSearchAlerts']
>[number];
